module.exports = __webpack_public_path__ + "static/media/wellesbourne-innovation-campus.7cf8fc73.jpg";